import { render, staticRenderFns } from "./ViewBlogFooter.vue?vue&type=template&id=cdf8768c&"
import script from "./ViewBlogFooter.vue?vue&type=script&lang=js&"
export * from "./ViewBlogFooter.vue?vue&type=script&lang=js&"
import style0 from "./ViewBlogFooter.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports